import {css, useTheme} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import userIcon from 'src/assets/icons/userIconMultiColor.svg';
import {GetStylesFunction} from 'src/js/common/types';

type Props = any;

export const DlMuiUserIconMultiColor: React.FC<Props> = (props) => {
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <SvgIcon
      css={styles.userIcon}
      component={userIcon}
      inheritViewBox
      {...props}
    />
  );
};

DlMuiUserIconMultiColor.displayName = 'DlMuiUserIconMultiColor';

const getStyles: GetStylesFunction = (options) => ({
  userIcon: css`
      width: 24px;
      height: 24px;
  `
});
